/**
 * Dónde guarda el site la sesión contra el API.
 *
 * Aparte del repositorio porque la leen dos: el repositorio, para las rutas, y
 * el socket de avisos (`tiempo-real.ts`), para saludar con ella. El socket se
 * importa desde las pantallas, y traer el repositorio entero solo para leer
 * una clave del almacenamiento lo metería en el paquete inicial.
 *
 * La sesión vive en `localStorage`. Es un token firmado por el servidor, no un
 * secreto compartido, y no habilita nada más que ver los propios datos: si
 * alguien llega al almacenamiento del navegador, ya tiene el navegador.
 */

const CLAVE_SESION = 'domino.site.token'

export function leerToken(): string | null {
  try {
    return localStorage.getItem(CLAVE_SESION)
  } catch {
    return null
  }
}

export function guardarToken(token: string | null): void {
  try {
    if (token === null) localStorage.removeItem(CLAVE_SESION)
    else localStorage.setItem(CLAVE_SESION, token)
  } catch {
    // Un navegador con el almacenamiento bloqueado sostiene la sesión hasta que
    // se recargue la página. Es peor que nada, pero mucho mejor que no entrar.
  }
}
